import ThemeButtonCircle from './Theme.Button.Circle';
import './Theme.Button.Floating.scss';
export default `${ThemeButtonCircle} ThemeButtonFloating`;
